export default __webpack_public_path__ + "static/media/fav-list-add-white.1942be26.svg";